export const version = `api/${process.env.REACT_APP_VERSION}/`;
export const getmenuUrl = version + 'Menu/getmenu';
export const saveseccategoryUrl = version + 'SEC/saveseccategory';

export const getCampaignListUrl = version + 'impression/GetCampaignList';
// export const getDoctorListUrl = version + 'impression/GetDoctorList?CampaignId=';
export const saveDoctorPosterUrl = version + 'impression/SaveDoctorPoster';
export const getAttendiesListUrl = version + 'impression/GetAttendiesList?DoctorDataId=';
export const saveAttendiesDataUrl = version + 'impression/SaveAttendiesData';
export const getAttendiesDataByIdUrl = version + 'impression/GetAttendiesDataById?DoctorDataId=';
//for add user on submit
// export const registerBulkUserUrl = version + 'impression/registerBulkUser';
//for onchange validate user
export const validateBulkUserUrl = version + 'impression/validatebulkuserlist';
export const getMasterdoctorList = version + 'impression/GetdoctorMasterList';


////Quetionnier
export const GetQuetionnnierListUrl = version + 'Questionnier/GetQuetionnnierList';
export const GetQuestionnierDataByIdUrl = version + 'Questionnier/GetQuestionnierDataById?Id=';
export const SaveQuestiondataUrl = version + 'Questioner/SaveQuesionAnswer';
export const GetDashboarddataUrl = version + 'DashboardData/GetDashboarddata';
// export const registerBulkUserUrl = version + 'doctor-employee-hierarchy/bulk-upload';



//QOL
export const getDoctorList = version + 'QualityOfLife/getPatientList';

export const SavepatientdetailsUrl = version + 'QualityOfLife/Savepatientdetails';
export const ExceportToExcelUrl = version + 'QualityOfLife/GetExporttoexcel';
export const ExceportToPDFUrl = version + 'QualityOfLife/GetExporttoPDF?PatientCode=';


//Chetna 


 export const SaveCampRequestUrl = 'camp-requests';
 //export const SavepatientdataUrl = 'patient-data';

 export const GetCampignListUrl = 'camp-requests';
 //export const GetTopcardsListUrl = 'camp-requests/dashboard-stats';
 //export const GetPatientListUrl = 'patient-data';
 export const GetPatientListByCampIdUrl = 'patient-data/GetPatientDataByrequestId/';
 export const GetCampignecordbyIdUrl = 'camp-requests/GetCampdetailsById/';
 export const GetpatientdatabyIdUrl = 'patient-data/GetPatentDataById/';
 export const getdoctorcodeverify =  'doctor-employee-hierarchy/verifydoctorcode/';
 export const HoApproverejectrequestUrl =  'camp-requests/approve-reject/';
 export const getCampRequestDataExportURL =  'camp-requests/export?startDate=';
 export const getpatientdataExportURL =  'patient-data/export?startDate=';
 export const filedownloadURL =  'camp-requests/download/';
 export const assignphleboURL =  'camp-requests/assign-phlebo/';
 export const registerBulkUserUrl =  'doctor-employee-hierarchy/bulk-upload/';


 //TITR 

  export const getDoctorListUrl = version + 'data/getDoctorList';
  export const getMasterDataUrl = version + 'data/getMasterdata';
  export const GetTopcardsListUrl = version + 'KneeHealthController/gettopcardData';
  
  export const SavepatientdataUrl = version +'MetabolicIQ/SavePatientdetails'
  export const SaveddoctordataUrl = version +'MetabolicIQ/Savedoctordetails'
  export const FectchpatientdetailsUrl = version +'MetabolicIQ/GetPatientdetails'
  export const FectchdoctordetailsUrl = version +'MetabolicIQ/GetDoctordetails'

  export const gethircrchymasterdataUrl = version +'KneeHealthController/GethirarchyList'
  export const getbelistbyEmpCodeUrl = version +'KneeHealthController/getbelistbyempcode'
  export const getbeandpatientlist = version + 'KneeHealthController/GetpatientListandsessionlistByEmocode?Empcode=';
  export const updateSessionstatusId = version + 'KneeHealthController/UpdatedsessionId?DoctorCode=';
  export const GetsessionListByDoctorcode = version + 'KneeHealthController/GetSessionListByDoctorcode?DoctorCode=';
  export const StartsessionUrl = version + 'KneeHealthController/CreatesessionId?DoctorCode=';
  export const SavepatientdetailsandanswerUrl = version + 'data/SaveTransactionData';
  export const getpatientquestionanswerlistByUrl = version + 'data/getPatientListById?Id=';
 export const GetSessionListUrl  = version + 'KneeHealthController/Getsesionlist?DoctorCode=';

 

 
 


//crewstudy


export const getuserdetailsUrl = version + 'Accounts/GetUserDetailsUserId/';

export const GetPatientListUrl = version + 'Patient/GetPatientList?DoctorCode=';
export const getpatienrdetailsbyid = version + 'Patient/GetPatienDetailsById?patientId=';
export const GetDoctorListUrl = version + 'Patient/GetDoctorList';
export const GetMedicationListUrl = version + 'Patient/GetMedicationList';
export const SavePatientdeatilsUrl = version + 'Patient/SavePatientDetails';
export const GetKPICarddataUrl = version + 'Patient/GetKPICards';
export const GetHOKPICarddataUrl = version + 'Patient/GetHOKPICards';
export const GetPatientListDataUrl = version + 'Patient/GetPatientListForSarthi';
export const getReportdeatilsUrl = version +'Patient/GetExporttoexcel?type='
export const GetgetregionwisedataDataUrl = version +'Patient/Getregiondata?RegionName='
 export const gethirerchylistUrl = version + 'Patient/GethirarchyList?Designation=';

  export const checkinvestigetersignaureUrl = version + 'Patient/CheckDoctorSignature?DoctorCode=';
  export const saveDoctorSignatureUrl = version + 'Patient/SaveDoctorSignatureDtaa';





  
export const GetuserLoginLogsUrl = version + 'Patient/GetuserLoginLogs?Month=';
export const SaveUserAppLogUrl = version + 'Patient/SaveUserAppLog';
export const GetBEdashboradKpiUrl = version + 'Patient/GetBEdashboarddata?Empcode=';
export const GetSMHodashboradKpiUrl = version + 'Patient/GetSMHOdashboarddata?Empcode=';
export const VerifydoctorUrl = version + 'Patient/verifydoctor?Doctorcode=';
